/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_invite_team_info = /** @type {(inputs: {}) => string} */ () => {
	return `Las invitaciones se enviarán por correo electrónico. Cada miembro recibirá un enlace para unirse a tu organización.`
};

const en_onboarding_invite_team_info = /** @type {(inputs: {}) => string} */ () => {
	return `Invitations will be sent by email. Each member will receive a link to join your organization.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_invite_team_info = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_invite_team_info(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_invite_team_info", locale)
	if (locale === "es") return es_onboarding_invite_team_info(inputs)
	return en_onboarding_invite_team_info(inputs)
};
export { onboarding_invite_team_info as "onboarding.invite_team.info" }